import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { GedService } from 'src/app/modules/ged/ged.service';
import { map, reduce } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SubMenuService {

  customer$:Observable<any>;
  subMenu$ = new BehaviorSubject<any[]>(null);
  subMenuMonth$ = new BehaviorSubject<any[]>(null);
  constructor(public gedService:GedService) { 
    this.customer$ = this.gedService.listCustomer();
    this.gedService.listGedUserGroup().pipe(
      map(items=>items.map(item=>({$key:item.key,...item.payload.val()})))
    )
    .subscribe(data=>{
      console.log(data);
      this.subMenu$.next(data);
    })

   
    this.gedService.listGedUserFile().pipe(
      
      map(items=>items.map(item=>({$key:item.key,...item.payload.val()}))
      .reduce((acc,val)=>{
        if (acc.filter(a=>{          
          return a.month.indexOf(val.month.substr(0,7))==0}).length==0) 
        acc.push(val); 
        return acc
      },[]) )
      
    )
    .subscribe(data=>{
      console.log(data);
      this.subMenuMonth$.next(data);
    })

  }
}
